export const CLEAR_PREPARATION_TIME_REPORT_DATA = "preparationTimeReport/clear"

export const createActionClearPreparationTimeReportData = () => ({
    type: CLEAR_PREPARATION_TIME_REPORT_DATA,
})

export const PREPARATION_TIME_AGENDA_MOUNTED = "PREPARATION_TIME_AGENDA_MOUNTED"

export const createActionPreparationTimeAgendaMounted = () => ({
    type: PREPARATION_TIME_AGENDA_MOUNTED,
})
